import { Col, Row } from 'antd';
import { AbstractForm } from './AbstractForm';
import { ConfigForm } from './ConfigForm';
import { DetailForm } from './DetailForm';
import { RichForm } from './RichForm';
import { StatusForm } from './StatusForm';
import { ReservationSlotList } from './ReservationSlotList';

export const ExperienceEventShow = () => {
  return (
    <Row gutter={[16, 16]}>
      <Col xl={24} lg={24} xs={24}>
        <StatusForm />
      </Col>

      <Col xl={24} lg={24} xs={24}>
        <ReservationSlotList />
      </Col>

      <Col xl={12} lg={24} xs={24}>
        <Row gutter={[16, 16]}>
          <Col xl={24} lg={24} xs={24}>
            <ConfigForm />
          </Col>
          <Col xl={24} lg={24} xs={24}>
            <AbstractForm />
          </Col>
          <Col xl={24} lg={24} xs={24}>
            <DetailForm />
          </Col>
        </Row>
      </Col>

      <Col xl={12} lg={24} xs={24}>
        <RichForm />
      </Col>
    </Row>
  );
};
